import { css, keyframes } from 'styled-components';

import { Z_INDEX } from './variables';

/* Fonts */

export const fontHeadingOne = css`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25rem;
`;

export const fontTextXsRegular = css`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.25rem;
`;

export const fontTextSmRegular = css`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.75rem;
`;

export const fontTextSmMedium = css`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.75rem;
`;

export const fontTextMdRegular = css`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625rem;
`;

/* Transitions */

export const transitionDuration = {
  fast: '0.1s',
  semiFast: '0.25s',
  normal: '0.4s',
  slow: '0.6s',
  verySlow: '2s',
};

/* Keyframes */

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const spin = keyframes`
  0% { 
      transform: rotate(360deg); 
  }

  100% { 
      transform: rotate(0deg); 
  }
`;

export const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
`;

export const turnYourDocument = keyframes`
  0% {
    opacity: 1;
  }

  24% {
    opacity: 1;
  }

  25% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
`;

/* Common positioning patterns */

export const centerHorizontally = css`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const centerBoth = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

/* Common component styles */

export const documentInstruction = css`
  ${fontHeadingOne};
  color: ${(p) => p.theme.colors.white};
  position: absolute;
  z-index: ${Z_INDEX.DOCUMENT_CAPTURE_SIDE};
  left: 50%;
  transform: translateX(-50%);
  top: 4%;
`;

export const animationContainer = css`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
`;

export const baseFrame = css`
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
  animation: ${turnYourDocument} ease-in-out 2s infinite;

  svg {
    width: 3rem;
    height: auto;
  }
`;

export const instructionText = css`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 3rem;
  color: ${(p) => p.theme.colors.white};
  text-align: center;
`;

export const overlayButtonGroup = css`
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  bottom: 15%;
  display: flex;
  gap: 0.5rem;
`;
